<template>
  <div>
    <div class="container">
      <section class="section">
        <HeadingLv3 text="カテゴリ一覧" band class="heading" />
        <div class="magazines_container">
          <MagazineCardList class="hiddenSp" :items="categoryListItems" />
          <MagazineCard
            v-for="category in categoryListItems"
            :key="category.id"
            :title="category.title"
            :image="category.image"
            :imageAlt="category.imageAlt"
            :path="category.path"
            class="hiddenPc card"
          />
        </div>
      </section>

      <section class="section">
        <HeadingLv3 text="キーワードから記事を探す" band class="heading" />
        <Keywords class="keywords" />
      </section>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, watch, PropType } from 'vue'
import MagazineCard from '@/components/block/MagazineCard.vue'
import MagazineCardList from '@/components/block/MagazineCardList.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import Keywords from '@/components/elements/Keywords.vue'
import { useSpecial } from '@/provider/special'
import { MagazineSpecialCategory } from '@/types/MagazineSpecial'

export default defineComponent({
  name: 'MagazinesFooter',

  props: {
    categories: {
      type: Array as PropType<MagazineSpecialCategory[]>,
      default: () => []
    }
  },

  components: {
    MagazineCard,
    MagazineCardList,
    HeadingLv3,
    Keywords
  },

  setup(props) {
    const { state, loadCategory } = useSpecial()

    if (!state.categories.length) loadCategory()
    const categoryList = computed(() => {
      if (props.categories.length) return props.categories
      return [...state.seriesCategories, ...state.specialCategories]
    })
    const categoryListItems = computed(() =>
      categoryList.value.map((cat) => ({
        id: cat.id,
        path: cat.path,
        title: cat.name,
        image: cat.spThumbUrl,
        imageAlt: cat.spThumbAlt
      }))
    )

    return {
      categoryListItems
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.section + .section {
  margin-top: 20px;
}
::v-deep(.heading .band) {
  font-weight: 300;
  font-size: 1.7rem;
  @include mixins.media() {
    margin: 0;
  }
}
.container {
  @include mixins.media() {
    border: 1px solid var.$color-border-gray;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  }
}
li {
  width: 100%;
}
.magazines_container {
  @include mixins.media() {
    padding: 0 16px;
  }
  @include mixins.mediaMax() {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-top: 20px;
    ::v-deep(.magazineCard_heading) {
      font-size: 1.2rem;
    }
  }
}
</style>
